// Loader de la configuración de lanzamiento desde Firestore (config/launch).
// Mientras clientsOpen === false, los clientes ven la pantalla de fundador
// (waitlist) en vez de la app. Sin doc o ante error cae a DEFAULTS (app abierta,
// comportamiento actual). NUNCA lanza. Cachea en memoria de módulo.
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const LAUNCH_DEFAULTS = {
  clientsOpen: true,
  founderWorkshopCap: 200,
};

let cachedConfig = null;

export async function loadLaunchConfig() {
  if (cachedConfig) return cachedConfig;
  try {
    const snap = await getDoc(doc(db, 'config', 'launch'));
    if (snap.exists()) {
      cachedConfig = { ...LAUNCH_DEFAULTS, ...snap.data() };
      return cachedConfig;
    }
  } catch (e) {
    // Silencioso: cualquier problema cae a defaults (app abierta).
  }
  return LAUNCH_DEFAULTS;
}
